import script from "./PeriodRangeDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./PeriodRangeDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./PeriodRangeDropdown.vue?vue&type=style&index=0&id=6a738db2&lang=css"

const __exports__ = script;

export default __exports__